import { render, staticRenderFns } from "./SunModel.vue?vue&type=template&id=2124f19a"
import script from "./SunModel.vue?vue&type=script&lang=js"
export * from "./SunModel.vue?vue&type=script&lang=js"
import style0 from "./SunModel.vue?vue&type=style&index=0&id=2124f19a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports